module.exports = __webpack_public_path__ + "/images/logo-babybazar-it.fd2bf01.jpg";